import { NavLink, Outlet, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { AppShell, UserBadge, useTheme, type SidebarSection } from '@koyomi/ui';
import { useAdminAuth } from '../../app/auth-store.ts';
import { api } from '../../lib/api.ts';

const NAV: [string, string][] = [
  ['dashboard', '/'], ['infra', '/infraestrutura'], ['businesses', '/negocios'], ['users', '/usuarios'], ['plans', '/planos'],
  ['providers', '/provedores'], ['aiProviders', '/ia'], ['integrations', '/integracoes'], ['costs', '/custos'],
  ['profit', '/lucros'], ['support', '/suporte'], ['audit', '/auditoria'], ['alerts', '/alertas'], ['help', '/ajuda'], ['settings', '/configuracoes'],
];

/** Sidebar escura do Admin (mockup 25), itens conforme o Plano Funcional do Admin. */
export function AdminLayout() {
  const { t } = useTranslation(['admin', 'common']);
  const { user, clear } = useAdminAuth();
  const location = useLocation();
  const queryClient = useQueryClient();
  useTheme();
  const sections: SidebarSection[] = [{ items: NAV.map(([key, href]) => ({ key, href, label: t(`admin:nav.${key}`), active: href === '/' ? location.pathname === '/' : location.pathname.startsWith(href) })) }];
  const logout = async () => {
    await api('/admin/auth/logout', { method: 'POST' }).catch(() => undefined);
    clear();
    queryClient.clear();
  };
  const initials = (user?.name ?? '?').split(' ').map((p) => p[0]).slice(0, 2).join('').toUpperCase();
  return (
    <AppShell
      brand={{ initial: 'S', title: t('admin:title'), subtitle: t('admin:subtitle'), dark: true }}
      sections={sections}
      renderLink={(it, className, children) => <NavLink key={it.key} to={it.href} className={className} end={it.href === '/'}>{children}</NavLink>}
      footer={
        <>
          <UserBadge initials={initials} name={user?.name} role={t('admin:subtitle')} />
          <button type="button" className="k-btn k-btn--ghost k-btn--sm" onClick={logout}>{t('common:actions.logout')}</button>
        </>
      }
    >
      <Outlet />
    </AppShell>
  );
}
